import {AfterViewInit, Component} from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'pm-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements AfterViewInit {

  constructor() {
  }

  ngAfterViewInit(): void {
    this.initSticky();

    if ($(window).width() > 10) {
      // footer fixed js
      $(document).ready(() => {
        const footerPadd = $('nav').height() + 'px';
        $('main').css('padding-top', footerPadd);
      });
    }

    $('.sreach-icon').click(() => {
      $('.products-search-top,body').addClass('active');
    });
    $('.close-icon,.overlay').click(() => {
      $('.products-search-top,body').removeClass('active');
    });

    $('.responsive_toggle .responsive_side_toggle,.seacr_coll').click(() => {
      $('.right_menu_responsive').addClass('active');
      // $(".overlay").addClass("active");
      $('body,html').addClass('active');
    });
    $('.right_menu_close,.overlay').click(() => {
      this.closeMenu();
    });
  }

  public closeMenu(): void {
    $('.right_menu_responsive').removeClass('active');
    // $(".overlay").removeClass("active");
    $('body,html').removeClass('active');
  }

  private initSticky(): void {
    // Get the header
    const header = document.getElementById('myHeader');
    // Get the offset position of the navbar
    const sticky = header.offsetTop;

    // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function myFunction(): void {
      if (window.pageYOffset > sticky) {
        header.classList.add('sticky');
      } else {
        header.classList.remove('sticky');
      }
    }

    // When the user scrolls the page, execute myFunction
    window.onscroll = myFunction;
  }

}
